import RoktContextProvider from './context'

export { default as RoktPlaceholder } from './placeholder'

const RoktProvider = ({ enabled = false, children }) => {
  if (!enabled) {
    return children
  }

  return (
    <RoktContextProvider tagId="2954612675718703810_ec8494683ef74fa9afe04d8fc35740d7">{children}</RoktContextProvider>
  )
}

export default RoktProvider
